module.exports = __webpack_public_path__ + "static/img/28.deb65ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/28.png
// module id = Q8iR
// module chunks = 0